var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDentitionType1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210 144.9",
    style: {
      enableBackground: "new 0 0 210 144.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#36393A;}\n\t.st1{fill:#FFFFFF;stroke:#36393A;}\n\t.st2{fill:#FDE3DF;stroke:#FF2C46;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;stroke:#CDD4D7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4162",
    className: "st0",
    d: "M207.1,124.7l1.4-16.2c0.4-6.3-4.1-11.8-10.4-12.6c-25.6-3-90.9,17.9-198-10.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4163",
    className: "st0",
    d: "M201.3,13.9l4.5,22.3c1.1,6.2-2.8,12.2-9,13.6c-25.2,5.8-92.5,17.6-188.8,7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4164",
    className: "st1",
    d: "M56.5,80.9c0,0,0.7,9.6,2.1,13c1.3,3.1,4.4,6.4,8.1,7.3c3.7,0.8,17,0.8,20.4-2.7 c2.2-2.2,3.8-5,4.4-8.1c0.6-2.3,2.7-8.3,1.8-10.4s-10-5.8-14.4-5.6S56.5,80.9,56.5,80.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4165",
    className: "st2",
    d: "M105.5,73.5c0,0-0.1-8.3-2.2-10.3c-2.5-2.4-6-3.5-9.4-3c-4.2,0.7-9.2,6.4-10.1,10.6 c-0.7,2.6,0.5,5.4,2.9,6.7c2.5,0.7,4.4-1.9,5.7-1.4c2.6,1,2.2,3.6,5,4.6c1.6,0.6,7.9-1.6,8-3S105.5,73.5,105.5,73.5L105.5,73.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4166",
    className: "st2",
    d: "M100.8,101.5c4.1,1.4,8.5,1.2,12.4-0.6c4.6-2.4,6.5-8.7,5.4-13.4s-4.7-7-5.6-7 c-3.3,0.3-4.1,3.6-5.9,3.6c-3.5,0-4.3-2.7-8.1-2.7c-2.1,0-5.3,3.1-5.7,6.8C92.7,93.5,97.4,100.2,100.8,101.5L100.8,101.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    className: "st3",
    d: "M97,118.6c-0.1,3.3,0.4,6.7,1.5,9.8c1.5,4.6,2.6,8.5,7.1,8.4c4.5-0.1,5.8-1.8,7.2-5 c1.2-3.1,2.2-6.2,3-9.4c0.4-2,0.2-4-0.8-5.8c-0.5-1.1-5.9-6-9.2-5.9C101.8,110.9,97,115.9,97,118.6L97,118.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    className: "st1",
    d: "M193.1,93.9c0,0,1.7,5,3.2,5.2s4.8-13.8,5.2-15.9c0.3-2,0.3-4,0-6l-11.2,3.2L193.1,93.9 L193.1,93.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4169",
    className: "st1",
    d: "M187.7,93.9c0,0,2.4,7.4,3.6,7.7s3.1-7,3.5-9.1c0.4-2.1,3.6-13.5,3.5-15.7S186.8,82,186.8,82 L187.7,93.9L187.7,93.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    className: "st1",
    d: "M178,91c0,0,0.3,12.7,6.6,12.5c1.8-0.2,2.8,0,8.7-24.6l-12.2-1.4L178,91z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    className: "st1",
    d: "M161.1,86.5c0.9,4.2,5.3,13.5,7.1,15.6c1.3,1.6,2.9,2.4,3.9,2.3s4.4-3,5.6-8s3.5-18.1,3.5-18.1 L160.6,79C160.6,81.5,160.8,84,161.1,86.5L161.1,86.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    className: "st2",
    d: "M141,88.8c-0.5,2.8,3.6,18.1,9.9,18.1c2.1,0,5.1-3.4,5.7-6.4c0.3-1.4,2.7-14.2,2.1-16.4 c-0.7-2.1-2.5-3.8-4.6-4.4c-2.5-0.4-7.7,1.4-9.8,2.7C142.5,83.6,141.4,86.9,141,88.8L141,88.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    className: "st3",
    d: "M141.4,121.3c0,0,2.7,10.6,3.9,13.8c0.7,2.4,2.3,4.5,4.5,5.8c2.2,1.5,6.6,3.8,9.1,3.2 s3.6-3.5,4-4.9c0.5-1.8,3.8-20.6,3-23.3c-0.9-2.7-3.1-4.7-5.8-5.5c-3.2-0.5-9.6,1.7-12.3,3.4C145.8,115,141.5,121.3,141.4,121.3 L141.4,121.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    className: "st3",
    d: "M117.8,119.5c0,0,2.5,10.7,3.8,14.6s3.3,9.2,7.6,10c4.3,0.8,7.7-0.6,8.4-3.8 c0.7-3.3,5.7-17.4,5.5-19.4s-3.5-5.5-5.4-6.9s-6.1-4-9.8-3.9C124.3,110.2,117.8,119.5,117.8,119.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    className: "st1",
    d: "M190.3,50.5c0,0,0-9.4,1.8-10.7s18.1,16.8,17.4,33.5c0,0,0,3.7-4.4,3.9c-2.2,0-4.3,0.4-6.4,1 L190.3,50.5L190.3,50.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4176",
    className: "st3",
    d: "M20.5,43.3c0,0,1.3-12.1,11.4-12.1s13.5,2.6,16.7,5.5s4.6,12.9,4.2,13.5s-5.1,6.7-11,6.8 c-3,0.1-7-4.8-8.9-4.9c-3.5-0.1-2.2,4.5-7,4.1C22.3,55.9,19.5,50.6,20.5,43.3L20.5,43.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4177",
    className: "st1",
    d: "M69.3,53.2c-5-1.3-10.3-0.1-14.4,3c-5,4-7.3,15-5.3,21.1s7.6,6.8,8.6,6.5 c3.8-0.9,4.3-5.6,6.4-5.9c4-0.6,5.4,3,9.8,2.3c2.4-0.4,7.2-4.9,6.8-9.2C80.8,67.1,73.4,54.4,69.3,53.2L69.3,53.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4178",
    className: "st3",
    d: "M84.4,29.3c0,0-2.9,13-1,15.5s4.7,5,8.1,4.7s8.3-3,9.4-3.9c1.3-1.1,3.8-3.8,4-6.6 s-1.8-6.4-2.7-8.5s-3.3-11.7-10.3-12C85.7,18.3,84.4,29.3,84.4,29.3L84.4,29.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4179",
    className: "st1",
    d: "M176.2,64.7c0,0,0.3-10.8,0.8-13.7c0.6-4,2.9-9.3,5.6-9.4s9.9,5.7,19.6,30.5c0,0,2.6,6-1.7,6.9 c-3.3,0.7-9.5,1.4-12.2,1.7c-1.2,0.1-2.3,0-3.5-0.3c-1.9-0.5-4.5-1.6-5.3-4C178,72.6,176.2,64.7,176.2,64.7L176.2,64.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4180",
    className: "st3",
    d: "M128.8,11.6c0,0.6,0.6,6.9,0.3,9.5c-0.2,1.6-2.9,6.9-0.1,10.4c2.7,3.5,7.2,10.7,16.2,9.5 c9-1.2,11.3-8.5,11.5-11.1c0.1-2.6-2-12.3-3.8-16.6c-1.8-4.4-8.1-13.8-16-12.8S128.8,11.5,128.8,11.6L128.8,11.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4181",
    className: "st2",
    d: "M134.9,59.9c-0.2,1.1-1.3,5.2,0.5,7.7c1.9,2.4,5.3,5.8,9.3,5.8c3.6,0,7.8-5.8,7.9-7.6 c0.1-1.8-1.4-8.4-2.6-11.3c-1.2-3-3.9-7.4-9.3-6.7S135.2,58.1,134.9,59.9L134.9,59.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4182",
    className: "st3",
    d: "M14.7,105.9c0,0-0.3,12.2,9.6,13.6s13.7-0.8,17.3-3.2s6.3-12.2,6-12.8s-4.2-7.3-10-8.3 c-3-0.5-7.6,3.8-9.5,3.6c-3.5-0.3-1.6-4.7-6.4-5.1C18.3,93.6,14.8,98.4,14.7,105.9L14.7,105.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4183",
    className: "st3",
    d: "M105.8,21.1c0,0-3.1,13.8,0.3,16s9.7,5.7,11.9,5.3s8.3-7.8,9.9-8.9c1.1-0.6,1.7-1.8,1.6-3 c0-0.9-4-7.8-5.1-12s-4.2-11.6-11-11.1S105.8,21.1,105.8,21.1L105.8,21.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4184",
    className: "st1",
    d: "M158.8,54.6c0,0,3.3-12.4,8.6-11.6c2.9,0.6,5,5.6,6.7,10.8s8.7,21.3,8.1,24.3s-5.2,3.3-5.2,3.3 s-10.2,0.2-11.5,0.2c-5.8,0-7.4-7.1-8.2-10.3C156.3,67.1,156.5,63.2,158.8,54.6L158.8,54.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4185",
    className: "st2",
    d: "M131.1,68.4c0,0-3-8-5.7-9.2c-3.3-1.4-7-1.3-10.1,0.4c-3.8,2.2-6.7,9.4-6.1,13.8 c0.3,2.8,2.4,5,5.1,5.4c2.7-0.2,3.6-3.4,5-3.3c2.8,0.1,3.4,2.7,6.5,2.7c1.7,0,7.1-4.3,6.7-5.7C132.1,71,131.1,68.3,131.1,68.4 L131.1,68.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4186",
    className: "st2",
    d: "M125.2,102.4c3.5,1.2,7.4,1,10.7-0.5c3.9-2.1,5.6-7.5,4.7-11.5c-0.9-4-2.3-6.1-4.9-6 c-2.9,0.1-4.2,2.5-5.8,2.5c-3,0-3.1-1.7-6.4-1.7c-1.8,0-4.5,2.7-4.9,5.9C118.3,95.5,122.4,101.3,125.2,102.4L125.2,102.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentitionType1);
export default __webpack_public_path__ + "static/media/dentition_type_1.4fc0a170886842688649f30ba9c73663.svg";
export { ForwardRef as ReactComponent };